import React, { useState, useEffect } from "react";
import combinedServices from "../../shared/services/user-service";
import setLocalData from "../../shared/localStorage/setData";
import { useForm } from "react-hook-form";
import { Modal, ModalBody, ModalHeader, Button, ModalFooter } from "reactstrap";
import { useLocation } from "react-router-dom";
import "./Login.scss";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Login = (props) => {
  let navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showbutton, setShowbutton] = useState(false);
  const [showLoginOrForgotPassword, setShowLoginOrForgotPassword] =
    useState("login");
  const [otpMode,setOtpMode] = useState("email")
  const [otp,setOtp] = useState('')
  const [newPassword,setNewPassword] = useState('')
  const [forgotPasswordStep,setForgotPasswordStep] = useState(0)
  const logo =
    "https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/logo.png";
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  // Modal open state
  const [modal, setModal] = React.useState(
    props.isLogin ? props.isLogin : false
  );

  useEffect(() => {
    const { pathname } = window.location;
    if (pathname === "/login") {
      setModal(true);
      setShowbutton(true);
    } else {
      setModal(false);
      setShowbutton(false);
    }
  }, [props.location]);
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLoginForm = async (e) => {
    var data = {
      email: email,
      password: password,
    };

    let login_response = await combinedServices.login(data);

    var login_data = login_response.data;

    if (login_response.status == 200) {
      let login_response_1 = {
        login_user_detail: login_response,
      };

      if (login_data.user.user_type == "superadmin") {
        window.location.href = "/admin-dashboard";

        setLocalData("admin_info", login_data);
      } else {
        var clubOfficerIn = login_data.user.clubOfficerIn.length;

        setLocalData("user_info", login_response_1);

        localStorage.setItem("parent_token", login_data.token);

        if (props.isLogin) {
          window.location.href = props.path;
          //navigate(props.path, { replace: true });
        } else if (clubOfficerIn > 0) {
          window.location.href = "/admin-dashboard";
          //navigate("../club-dashboard", { replace: true });
        } else {
          //window.location.href = "/user-dashboard";
          window.location.href = "/club-dashboard";
          //navigate("../user-dashboard", { replace: true });
        }
      }
    } else {
      setErrorMsg(login_response.msg);
      e.target.reset();
    }
  };

  const onSubmit = async (data, e) => {
    //e.preventDefault();
    var data = {
      email: data.email,
      password: data.password,
    };

    let login_response = await combinedServices.login(data);

    var login_data = login_response.data;

    if (login_response.status == 200) {
      let login_response_1 = {
        login_user_detail: login_response,
      };

      if (login_data.user.user_type == "superadmin") {
        window.location.href = "/admin-dashboard";

        setLocalData("admin_info", login_data);
      } else {
        var clubOfficerIn = login_data.user.clubOfficerIn.length;

        setLocalData("user_info", login_response_1);

        localStorage.setItem("parent_token", login_data.token);

        if (props.isLogin) {
          window.location.href = props.path;
          //navigate(props.path, { replace: true });
        } else if (clubOfficerIn > 0) {
          window.location.href = "/club-dashboard";
          //navigate("../club-dashboard", { replace: true });
        } else {
          //window.location.href = "/user-dashboard";
          window.location.href = "/club-dashboard";
          //navigate("../user-dashboard", { replace: true });
        }
      }
    } else {
      

      
      setErrorMsg(login_response.msg);
      e.target.reset();
    }
  };

  // Toggle for Modal
  const toggle = () => {
    setModal(!modal);
  };
  const registerq = () => {
    window.location.href =
      " https://member.namba.com/index.php?page=getstarted";
  };

  
  const handleChange = () => {
    window.location.href =
      "https://member.namba.com/index.php?page=forgot-pass";
    // window.open('https://member.namba.com/index.php?page=forgot-pass', '_blank');
  };

  const handleForgotPassword = async () => {
    console.log("🚀 ~ handleForgotPassword ~ forgotPasswordStep:", forgotPasswordStep);
    setErrorMsg("");
  
    if (forgotPasswordStep === 1) {
      try {
        const res = await combinedServices.generateOtpForForgotPassword({ email, method: otpMode });
        console.log("🚀 ~ handleForgotPassword ~ res:", res);
  
        if (res.data.status === 200) {
          setForgotPasswordStep(2);
        } else {
          setErrorMsg(res.data.msg);
        }
      } catch (error) {
        setErrorMsg("Something went wrong, please try again.");
      }
    } else if (forgotPasswordStep === 2) {
      try {
        const res = await combinedServices.submitOtpAndPassword({ otp, newPassword, email });
  
        if (res.data.status === 200) {
          setNewPassword("");
          setOtp("");
          setForgotPasswordStep(0);
          setShowLoginOrForgotPassword("login"); // Switch back to login
          
          // Show success alert
          Swal.fire({
            icon: "success",
            title: "Password Reset Successful",
            text: "You can now log in with your new password.",
            confirmButtonText: "OK"
          });
        } else {
          setErrorMsg(res.data.msg);
        }
      } catch (error) {
        setErrorMsg("Invalid OTP or failed to reset password.");
      }
    }
  };
  
  
  return (
    <>
      <div>
        {showbutton ? "" : <a onClick={toggle}>Login</a>}
        <Modal isOpen={modal}>
          <ModalHeader className="loginHeader">
            {modal && showbutton ? (
              ""
            ) : (
              <Button className="close">
                <span class="material-icons" translate="no" onClick={toggle}>
                  close
                </span>
              </Button>
            )}
            <div className="popupLogo">
              <img src={logo} alt="NAMBA" />
            </div>
          </ModalHeader>
          <ModalBody className="loginInner">
            {showLoginOrForgotPassword === "login" && (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <ul className="flexBox loginForm">
                    <li>
                      <span className="fieldHd">Email</span>
                      <input
                        type="text"
                        className="formInput"
                        placeholder="Enter your email"
                        name="email"
                        onChange={handleEmailChange}
                      />
                    </li>
                    <li>
                      <span className="fieldHd">Password</span>
                      <input
                        type="password"
                        className="formInput"
                        placeholder="Enter your password"
                        name="password"
                        onChange={handlePasswordChange}
                      />
                    </li>
                  </ul>
                  {errorMsg && (
                    <span
                      style={{ "text-align": "center" }}
                      className="errorMsg"
                    >
                      {errorMsg}
                    </span>
                  )}
                  <div className="LoginBtn">
                    <Button
                      type="submit"
                      onClick={handleLoginForm}
                      className="formBtn"
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            )}
            {showLoginOrForgotPassword === "forgotPassword" && (
              <form onSubmit={handleSubmit(handleForgotPassword)}>
                <div>
                  <ul className="flexBox loginForm">
                    {forgotPasswordStep==1 && <>
                      <li>
                      <span className="fieldHd">Email</span>
                      <input
                        type="text"
                        className="formInput"
                        placeholder="Enter your email"
                        name="email"
                        onChange={(e)=>setEmail(e.target.value)}
                        required
                      />
                    </li>

                    <li>
                      <span className="fieldHd">Send OTP via:</span>
                      <div className="otpMode">
                        <label>
                          <input
                            type="radio"
                            name="otpMode"
                            value="email"
                            checked={otpMode === "email"}
                            onChange={(e)=>setOtpMode(e.target.value)}
                          />
                          Email
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="otpMode"
                            value="sms"
                            checked={otpMode === "sms"}
                            onChange={(e)=>setOtpMode(e.target.value)}
                          />
                          SMS
                        </label>
                       
                      </div>
                    </li>
                    </>}
                   
                  {forgotPasswordStep==2 &&<> <li>
                      <span className="text">OTP</span>
                      <input
                        type="text"
                        className="formInput"
                        placeholder="Enter the otp"
                        name="otp"
                        onChange={(e)=>setOtp(e.target.value)}
                      />
                    </li>
                    <li>
                      <span className="text">New Password</span>
                      <input
                        type="password"
                        className="formInput"
                        placeholder="Enter the new password"
                        name="newPassword"
                        onChange={(e)=>setNewPassword(e.target.value)}
                      />
                    </li></> }
                  </ul>

                  {errorMsg && (
                    <span style={{ textAlign: "center" }} className="errorMsg">
                      {errorMsg}
                    </span>
                  )}

                  <div className="LoginBtn">
                    <Button
                      type="submit"
                      className="formBtn"
                    >
                      {forgotPasswordStep==1 ? "Get Otp" :"Reset Password"}
                    </Button>
                  </div>
                </div>
              </form>
            )}

            <div className="regText" style={{display:'flex',gap:'10px',flexDirection:'column'}}>
             {showLoginOrForgotPassword=="login" ? <Button className="regbtn" onClick={()=>{
              setShowLoginOrForgotPassword('forgotPassword')
              setForgotPasswordStep(1)
              }}>
                Forgot Password
              </Button>:<Button className="regbtn" onClick={()=>setShowLoginOrForgotPassword('login')}>
                Back to login
              </Button>}

              <Button onClick={registerq} type="button" className="regbtn">
                Register
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default Login;
